import React, { useReducer, useMemo } from "react";
import { OPItemContext, opItemReducer, initialOPItemState } from "./OPItemContext";

interface IContextProviderProps {
    children: React.ReactNode;
}

export const OPItemContextProvider: React.FC<IContextProviderProps> = ({ children }: { children: React.ReactNode }): React.ReactElement => {
    const [opItemState, opItemDispatch] = useReducer(opItemReducer, initialOPItemState);
    const opItemContext = useMemo(() => ({ opItem: opItemState, setOPItem: opItemDispatch }), [opItemState]);

    return <OPItemContext.Provider value={opItemContext}>{children}</OPItemContext.Provider>;
};
